import { render, staticRenderFns } from "./channelFlow.vue?vue&type=template&id=487bb9a6&scoped=true"
import script from "./channelFlow.vue?vue&type=script&lang=js"
export * from "./channelFlow.vue?vue&type=script&lang=js"
import style0 from "./channelFlow.vue?vue&type=style&index=0&id=487bb9a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487bb9a6",
  null
  
)

export default component.exports